import {APP} from 'jsAssets/constants/app';
import _u from "jsAssets/utils/index";

// initial state
const state = {
    orders: null,
    ordersMessages: null,
};

// getters
const getters = {
    orders: state => state.orders,
    ordersMessages: state => state.ordersMessages,
};

// actions
const actions = {
    getOrders({ commit }, item) {
        let params = {
            'handler': 'order',
            'func': 'getOrders',
            'userId': item.userId,
            'dateFrom': item.dateFrom,
            'dateTo': item.dateTo,
            'quantity': item.quantity,
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setOrders', responseData.data.data.ORDERS.ORDER);
        commit('setOrdersMessages', responseData.data.data.ORDERS.MESSAGES);
        commit('app/setLoadingData', false, { root: true });
    });
    },

};

// mutations
const mutations = {
    setOrders (state, orders) {
        state.orders = orders;
    },
    setOrdersMessages (state, ordersMessages) {
        state.ordersMessages = ordersMessages;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
